import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import {
    failureCourseResourceMeta,
    successCourseResourceMeta,
} from "./CourseResourceMetaSlice";

const CourseResourceMetaApi = (action: PayloadAction<any>) => {
    return api.get("/api/course/resource_meta", {
        params: action.payload,
    });
};

export function* CourseResourceMetaCall(action: PayloadAction<any>) {
    try {
        const response: AxiosResponse = yield call(CourseResourceMetaApi, action);
        yield put(successCourseResourceMeta(response.data));
    } catch (error) {
        yield put(failureCourseResourceMeta(error));
    }
}
